// modules/Multiplayer/MultiplayerInputDialog.js
// 多人游戏输入对话框模块

export default class MultiplayerInputDialog {
    constructor(scene) {
        this.scene = scene;
    }
    
    /**
     * 显示输入对话框
     * @param {string} key - 字段键名
     * @param {string} label - 标签文本
     * @param {string} currentValue - 当前值
     * @param {Function} onConfirm - 确认回调 (value) => void
     * @param {Function} onCancel - 取消回调 () => void
     */
    showInputDialog(key, label, currentValue, onConfirm = null, onCancel = null) {
        // 创建输入对话框
        const dialogBg = this.scene.add.graphics();
        dialogBg.fillStyle(0x1a1a2e, 0.95);
        dialogBg.fillRoundedRect(
            this.scene.cameras.main.centerX - 200,
            this.scene.cameras.main.centerY - 60,
            400,
            120,
            10
        );
        dialogBg.lineStyle(3, 0x4cc9f0, 1);
        dialogBg.strokeRoundedRect(
            this.scene.cameras.main.centerX - 200,
            this.scene.cameras.main.centerY - 60,
            400,
            120,
            10
        );
        
        const labelText = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.centerY - 30,
            label,
            {
                fontSize: '16px',
                fill: '#ffffff',
                fontFamily: 'monospace'
            }
        );
        labelText.setOrigin(0.5);
        
        // 使用浏览器原生输入框
        const input = document.createElement('input');
        input.type = 'text';
        input.value = currentValue;
        input.style.position = 'absolute';
        input.style.left = (this.scene.cameras.main.centerX - 180) + 'px';
        input.style.top = (this.scene.cameras.main.centerY) + 'px';
        input.style.width = '360px';
        input.style.height = '30px';
        input.style.fontSize = '14px';
        input.style.fontFamily = 'monospace';
        input.style.backgroundColor = '#2a2a3e';
        input.style.color = '#ffffff';
        input.style.border = '2px solid #4cc9f0';
        input.style.borderRadius = '5px';
        input.style.padding = '5px';
        input.style.zIndex = '10000';
        document.body.appendChild(input);
        input.focus();
        input.select();
        
        // 确定按钮
        const confirmButton = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.centerY + 30,
            '确定',
            {
                fontSize: '16px',
                fill: '#ffffff',
                fontFamily: 'monospace',
                backgroundColor: '#4cc9f0',
                padding: { x: 20, y: 8 }
            }
        );
        confirmButton.setOrigin(0.5);
        confirmButton.setInteractive({ useHandCursor: true });
        
        const closeDialog = () => {
            const value = input.value.trim();
            document.body.removeChild(input);
            dialogBg.destroy();
            labelText.destroy();
            confirmButton.destroy();
            
            if (value && onConfirm) {
                onConfirm(value);
            } else if (onCancel) {
                onCancel();
            }
        };
        
        confirmButton.on('pointerdown', closeDialog);
        
        input.addEventListener('keydown', (e) => {
            if (e.key === ' ' || e.code === 'Space') {
                closeDialog();
            } else if (e.key === 'Escape') {
                document.body.removeChild(input);
                dialogBg.destroy();
                labelText.destroy();
                confirmButton.destroy();
                if (onCancel) onCancel();
            }
        });
    }
    
    /**
     * 显示创建房间对话框
     * @param {string} defaultRoomName - 默认房间名称
     * @param {Function} onConfirm - 确认回调 (roomName) => void
     * @param {Function} onCancel - 取消回调 () => void
     */
    showCreateRoomDialog(defaultRoomName, onConfirm = null, onCancel = null) {
        // 创建输入对话框
        const dialogBg = this.scene.add.graphics();
        dialogBg.fillStyle(0x1a1a2e, 0.95);
        dialogBg.fillRoundedRect(
            this.scene.cameras.main.centerX - 200,
            this.scene.cameras.main.centerY - 80,
            400,
            160,
            10
        );
        dialogBg.lineStyle(3, 0x4cc9f0, 1);
        dialogBg.strokeRoundedRect(
            this.scene.cameras.main.centerX - 200,
            this.scene.cameras.main.centerY - 80,
            400,
            160,
            10
        );
        
        const titleText = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.centerY - 50,
            '创建房间',
            {
                fontSize: '20px',
                fill: '#4cc9f0',
                fontFamily: 'monospace',
                fontWeight: 'bold'
            }
        );
        titleText.setOrigin(0.5);
        
        const nameLabel = this.scene.add.text(
            this.scene.cameras.main.centerX - 180,
            this.scene.cameras.main.centerY - 20,
            '房间名称:',
            {
                fontSize: '14px',
                fill: '#ffffff',
                fontFamily: 'monospace'
            }
        );
        nameLabel.setOrigin(0, 0.5);
        
        // 使用浏览器原生输入框
        const input = document.createElement('input');
        input.type = 'text';
        input.value = defaultRoomName || '';
        input.placeholder = '输入房间名称';
        input.style.position = 'absolute';
        input.style.left = (this.scene.cameras.main.centerX - 180) + 'px';
        input.style.top = (this.scene.cameras.main.centerY) + 'px';
        input.style.width = '340px';
        input.style.height = '30px';
        input.style.fontSize = '14px';
        input.style.fontFamily = 'monospace';
        input.style.backgroundColor = '#2a2a3e';
        input.style.color = '#ffffff';
        input.style.border = '2px solid #4cc9f0';
        input.style.borderRadius = '5px';
        input.style.padding = '5px';
        input.style.zIndex = '10000';
        document.body.appendChild(input);
        input.focus();
        input.select();
        
        // 确定按钮
        const confirmButton = this.scene.add.text(
            this.scene.cameras.main.centerX - 50,
            this.scene.cameras.main.centerY + 40,
            '创建',
            {
                fontSize: '16px',
                fill: '#ffffff',
                fontFamily: 'monospace',
                backgroundColor: '#00aa00',
                padding: { x: 20, y: 8 }
            }
        );
        confirmButton.setOrigin(0.5);
        confirmButton.setInteractive({ useHandCursor: true });
        
        // 取消按钮
        const cancelButton = this.scene.add.text(
            this.scene.cameras.main.centerX + 50,
            this.scene.cameras.main.centerY + 40,
            '取消',
            {
                fontSize: '16px',
                fill: '#ffffff',
                fontFamily: 'monospace',
                backgroundColor: '#666666',
                padding: { x: 20, y: 8 }
            }
        );
        cancelButton.setOrigin(0.5);
        cancelButton.setInteractive({ useHandCursor: true });
        
        const closeDialog = (create = false) => {
            const roomName = input.value.trim();
            document.body.removeChild(input);
            dialogBg.destroy();
            titleText.destroy();
            nameLabel.destroy();
            confirmButton.destroy();
            cancelButton.destroy();
            
            if (create && roomName && onConfirm) {
                onConfirm(roomName);
            } else if (onCancel) {
                onCancel();
            }
        };
        
        confirmButton.on('pointerdown', () => closeDialog(true));
        cancelButton.on('pointerdown', () => closeDialog(false));
        
        input.addEventListener('keydown', (e) => {
            if (e.key === ' ' || e.code === 'Space') {
                closeDialog(true);
            } else if (e.key === 'Escape') {
                closeDialog(false);
            }
        });
    }
}

